<template>
    <div class="handleList">
        <!-- 筛选功能 -->
        <div class="search_query">
            <div class="item" @click="showCity">
                <span class="city">{{md.cityPickerValue}}</span>
                <img src="../../../../../assets/image/jiantou.png" class="jian" />
            </div>
            <div class="item" @click="showTime">
                <span class="city">{{md.datePickerValue}}</span>
                <img src="../../../../../assets/image/jiantou.png" class="jian" />
            </div>
        </div>
        <div class="header_count">共有{{ totalCount }}件</div>
        <van-list
            ref="vanList"
            v-model="loading"
            :finished="finished"
            :finished-text="finishedText"
            :immediate-check="false"
            @load="onLoad"
            class="wrapper"
        >
            <div class="reject" v-for="(item,index) in proList" :key="index" @click="goDetail(item)">
                <div class="reject_item">
                    <div class="box_item">
                        <div class="title">
                        <p class="title_text">{{item.defendantName }}</p>
                        <p
                        class="title_tag1"
                        :class="sstt[!item.urgencyDegree && item.urgencyDegree !== 0 ? '': Number(item.urgencyDegree-7)]"
                         >{{sttText[!item.urgencyDegree && item.urgencyDegree !== 0 ? '': Number(item.urgencyDegree-7)]}}</p>
                        </div>
                        <div class="info">
                            <span>所属区域：</span>
                            <span>{{item.belongMechanismName}}</span>
                        </div>
                        <div class="info">
                            <span>投诉人：</span>
                            <span>{{item.complainName}}</span>
                        </div>
                        <div class="info">
                            <span>投诉时间：</span>
                            <span>{{ item.complainTime }}</span>
                        </div>
                        <div class="info">
                            <span>时长时限：</span>
                            <span class="info_time">{{item.handleTime|filt3()}}</span>
                            <span></span>
                            <span>{{item.handleTimeLimit|filt4()}}</span>
                        </div>

                        <div class="info">
                            <div class="tag1" v-for="(item1,index1) in item.typeLevel" :key="index1" :class="tagIndex[item1 == '' ? '': Number(item1 - 1)]">{{
                                tags[item1 === '' ? '' : Number(item1 - 1)]
                                }}</div>
                        </div>
                        <div class="info1" v-show="type === 'otherSupervision'">
                            <div class="info1_title">督办人：</div>
                            <div>
                                <div v-for="(e, i) in item.superviseUserName" :key="i" class="info1_certer">
                                    <span class="info1_span">{{ e }}</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="line"></div>
                    <div class="status">
                        <p class="info_text">{{item.statueName}}</p>
                        <p>
                            <span class="info_text1">查看详情</span>
                            <span>
                                <img src="../../../../../assets/image/right.png" alt=""/>
                            </span>
                        </p>
                    </div>
                </div>
            </div>
        </van-list>
        <isNoInfo :isNolist="isNolist"></isNoInfo>
        <common-picker v-if="areaList.length" ref="commonPicker1" :typeList="areaList" :cols="cols1" @getTypeValue="getCityValue"></common-picker>
        <common-picker ref="commonPicker3" :typeList="typeList3" :cols="cols3" @getTypeValue="getValue" :isShowAbountButton="false"  @showRangTime="showRangTime"></common-picker>
    </div>
</template>
<script>
    import complaintApis from './../../../../../service/modules/complaintApis';
    import isNoInfo from '../../../../../components/isNoInfo.vue';
    import util from '../../../../../utils/common'
    import { complaintTime } from '../../../../../utils/configJson';
    import commonPicker from '../../../../../components/base/commonPicker';
    export default {
        components: {
            isNoInfo,
            commonPicker
        },
        data () {
            return {
                type: (this.$route.query || {}).type || 'mySupervision',
                sstt: ['ss1', 'ss2', 'ss3'],
                sttText: ['一般', '较重', '严重'],
                finishedText: '没有更多',
                finished: false, /** 设置滚动加载 */
                loading: true, /** 滚动加载loading */
                proList: [], // 列表
                pageIndex: '0',
                startTime: '', /** 筛选时间-开始时间 */
                endTime: '', /** 删选时间-结束时间 */
                ishowRangeTime: false,
                scrollY: 0,
                timer: null,
                pickerValue: '',
                pageSize: '10',
                isNolist: false, // 没有内容的状态
                isload: true, // 底部加载中的状态
                message: '加载中...',
                bottomStatus: '',
                isHide: false,
                isShow: false,
                md: {
                    datePickerValue: '筛选时间',
                    typePickerValue: '投诉渠道',
                    cityPickerValue: this.$route.query.fullAddress,
                    cityCode: this.$route.query.value,
                    areaId: this.$route.query.areaOne
                },
                areaList: [],
                cols1: 2,
                typeList3: complaintTime(),
                cols3: 3,
                tags: ['省级督办', '州市督办', '区县督办'],
                tagIndex: ['tag1', 'tag2', 'tag3'],
                totalCount: 0 /** 总共条数 */
            }
        },
        computed: {
            deptInfo () {
                return this.$store.state.complaint.deptInfo;
            }
        },
        created () {
            var that=this;
            yyn.invokeJSB('setActionBar',{icon:"change", title:that.type === 'mySupervision' ? '其他督办' : '我的督办'}, that.handleTonggleRoute)
            window.yyn.invokeJSB(
              'setTitle',
              {
                title:that.type === 'otherSupervision' ? '其他督办' : '我的督办'
              },
              cb => {
                console.log('设置title成功：', data);
              }
            );
            that.getList();
            that.getAllCity();
        },
        methods: {
            // 切换其他督办和我的督办
            handleTonggleRoute() {
                if(this.type=='mySupervision'){//我的督办
                        this.$router.replace({
                            path: '/complaint/handle',
                            query: {
                                fullAddress:this.md.cityPickerValue,
                                areaOne:this.md.areaId,
                                value:this.md.cityCode,
                                type:'otherSupervision'
                            }
                        })
                    }else{
                        this.$router.replace({
                            path: '/complaint/handle',
                            query: {
                                fullAddress: this.md.cityPickerValue,
                                areaOne: this.md.areaId,
                                value: this.md.cityCode,
                                type:'mySupervision'
                            }
                        })
                    }
            },
            goDetail (value) {
                this.$router.push({
                    name: 'workListDetails',
                    params: {
                        item: value
                    }
                });
                util.setJsonLocal('buttonType', this.type);
                util.setJsonLocal('item', value);
                this.$store.commit('complaint/getItemList', value);
                this.$store.commit('complaint/setCheckList', false);
            },
            showRangTime () {
                setTimeout(() => {
                    this.ishowRangeTime = true;
                }, 500)
            },
            showCity () {
                this.$refs.commonPicker1.showPicker();
            },
            showTime () {
                this.$refs.commonPicker3.showPicker();
            },
            getCityValue (value) {
                if (value.length > 1) {
                    this.md.cityPickerValue = value[0].label + '-' + value[1].label;
                    this.md.areaId = value[1].areaId;
                } else {
                    this.md.cityPickerValue = value[0].label;
                    this.md.areaId = value[0].areaId;
                }
                this.getList();
            },
            /** 获取时间 */
            getValue (value) {
                if (value[1].key === 'year') {
                    this.md.datePickerValue = value[0].value + '年';
                    this.startTime = value[0].value + '-' + value[1].value1 + ' ' + '00:00:00';
                    this.endTime = value[0].value + '-' + value[1].value2 + ' ' + '23:59:59';
                } else if (value[1].key === 'quarter') {
                    this.md.datePickerValue = value[0].value + value[2].text;
                    this.startTime = value[0].value + '-' + value[2].value1 + ' ' + '00:00:00';
                    this.endTime = value[0].value + '-' + value[2].value2 + ' ' + '23:59:59';
                } else if (value[1].key === 'moutn') {
                    this.md.datePickerValue = value[0].value + '年' + value[2].value1 + '月';
                    const d = new Date(value[0].value, value[2].value1, 0)// 获取当月的天数
                    this.startTime = value[0].value + '-' + value[2].value1 + '-01' + ' ' + '00:00:00';
                    this.endTime = value[0].value + '-' + value[2].value1 + '-' + d.getDate() + ' ' + '23:59:59';
                }
                this.proList = [];
                this.getList();
            },
            // 初始化区域数据列表
            getAllCity () {
                // 获取所有的市
                const params = {
                    data: {
                        cityCode: this.deptInfo.txId
                    }
                };
                this.$store.dispatch('complaint/region', params).then(data => {
                    // 当前用户所属城市下级城市列表
                    if (this.deptInfo.areaLevel === '1') {
                        this.cols1 = 2;
                    } else if (this.deptInfo.areaLevel === '2') { // 省级权限
                        this.cols1 = 2;
                    } else { // 区县权限
                        this.cols1 = 1;
                    }
                    this.areaList = [data];
                    this.$nextTick(() => {
                        this.$refs.commonPicker && this.$refs.commonPicker._initFresh();
                    })
                });
            },
            getList () {
                this.proList = [];
                this.pageIndex = 1;
                const data = {
                    data: {
                        curPage: this.pageIndex,
                        pageSize: 10,
                        data: {},
                        cityId: this.md.areaId,
                        startDate: this.startTime,
                        endDate: this.endTime,
                        type: this.type // 类型；1.mySupervision我的督办列表；2.otherSupervision其他督办列表
                    }
                }
                complaintApis.supervise.superviseList(data).then(res => {
                    this.loading = false; // 加载参数
                    const list = (res.data || {}).list || [];
                    this.totalCount = res.data.total || 0;
                    if (list.length > 0) { // 有数据
                        this.proList = res.data.list;
                        if (list.length === res.data.total) { // 已加载完了
                            this.finished = true;
                            this.loading = false;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                        this.isNolist = false;
                    } else {
                        this.finished = true;
                        this.loading = false;
                        this.isNolist = true;
                        this.finishedText = '';
                        this.isNolist = true;
                    }
                })
            },
            getMore () {
                const data = {
                    data: {
                        curPage: this.pageIndex,
                        pageSize: 10,
                        cityId: this.md.areaId,
                        startDate: this.startTime,
                        endDate: this.endTime,
                        type: this.type
                    }
                }
                complaintApis.supervise.superviseList(data).then((res) => {
                    this.totalCount = res.data.total || 0;
                    if (res.data.list.length > 0) { // 有数据
                        this.proList = this.proList.concat(res.data.list);
                        if (this.proList.length === res.data.total) {
                            this.finished = true;
                            this.loading = false;
                        } else {
                            this.finished = false;
                            this.loading = false;
                        }
                    }
                })
            },
            onLoad () {
                this.pageIndex++;
                this.getMore();
            }
        },
        filters: {
            filtTime (str) {
                var date = new Date(str);// 时间戳为10位需*1000，时间戳为13位的话不需乘1000
                var Y = date.getFullYear() + '-';
                var M = (date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1) + '-';
                var D = (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) + ' ';
                var h = (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) + ':';
                var m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) + ':';
                var s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
                let strDate = Y + M + D + h + m + s;
                return strDate;
            },
            // 时长计算
            filt3 (value) {
                var theTime = parseInt(value);// 秒
                var middle= 0;// 分
                var hour= 0;// 小时

                if(theTime > 60) {
                    middle= parseInt(theTime/60);
                    theTime = parseInt(theTime%60);
                    if(middle> 60) {
                        hour= parseInt(middle/60);
                        middle= parseInt(middle%60);
                    }
                }
                var result = ""+parseInt(theTime)+"秒";
                if(middle > 0) {
                    result = ""+parseInt(middle)+"分"+result;
                }
                if(hour> 0) {
                    result = ""+parseInt(hour)+"小时"+result;
                }
                return result;
            },
            // 计算时限
            filt4 (str) {
                let duration = str;
                let zero = function (times) {
                    return times;
                }
                let hour = zero(Math.floor(duration / 3600));
                let minutes = zero(Math.ceil((duration / 60 % 60)));
                let times = ''
                if (hour > 0) {
                    times += hour + 'h';
                }
                if (minutes > 0) {
                    times += minutes + 'm';
                }
                return times
            }
        }
    }
</script>
<style lang="less" scoped>
.handleList {
    width:100%;
    height:100%;
    background-color: @base-background;
    .search_query {
        background: #fff;
        width: 100%;
        height: 42px;
        display: flex;
        display: -webkit-flex;
        flex-direction: row;
        -webkit-flex-direction: row;
        // border-bottom: 1px solid #eee;
        .item {
            flex: 1;
            text-align: center;
            line-height: 42px;
            .city {
                margin-right: 4px;
                display: inline-block;
                vertical-align: middle;
                font-size: 12px;
                color: #666;
                max-width: 110px;
                overflow: hidden;
                white-space: nowrap;
                text-overflow: ellipsis;
            }
            .jian {
                width: 6px;
                height: 4px;
                display: inline-block;
                vertical-align: middle;
            }
        }
    }
    .header_count {
        padding-top: 24px;
        padding-left: 12px;
        font-size: 20px;
        color: #333333;
        font-weight: bold;
        line-height: 20px;
    }
    .wrapper {
        width: 100%;
        padding-top: 12px;
            .reject {
                width: 100%;
                padding-bottom: 16px;
            .reject_item {
                margin:0 12px;
                box-sizing: border-box;
                background-color: #fff;
                padding-bottom: 0;
                box-shadow: 0px 5px 20px 5px rgba(0, 0, 0, 0.04);
                border-radius: 3px;
                .box_item{
                    padding: 16px 16px 4px 16px;
                    box-sizing: border-box;
                    width:100%;
                    .info {
                        margin-top: 12px;
                        span:nth-child(1) {
                            display: inline-block;
                            width: 80px;
                            font-size: 14px;
                            color: #777;
                        }
                        span:nth-child(2) {
                            display: inline-block;
                            font-size: 14px;
                            color: #777;
                        }
                        span:nth-child(3) {
                            display: inline-block;
                            content: '';
                            margin: -8px 5px;
                            background: #999;
                            width: 1px;
                            height: 16px;
                            -webkit-transform: scaleY(0.5);
                            transform: scale(0.5);
                            -webkit-transform-origin: 0 0;
                            transform-origin: 0 0;
                        }
                        span {
                            font-size: 12px;
                            color: #666666;
                        }
                        .tag1 {
                            padding: 1px;
                            position: relative;
                            border: none;
                            display: inline-block;
                            margin-right: 12px;
                            color: #FF4D4D;
                        }
                        .tag1:after {
                            content: " ";
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 200%;
                            height: 200%;
                            border: 1px solid #FF4D4D;
                            -webkit-transform-origin: 0 0;
                            border-radius: 2px;
                            transform-origin: 0 0;
                            -webkit-transform: scale(0.5);
                            transform: scale(0.5);
                        }
                        .tag2 {
                            position: relative;
                            border: none;
                            display: inline-block;
                            margin-right: 12px;
                            color: #FF8C19;
                        }
                        .tag2:after {
                            content: " ";
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 200%;
                            height: 200%;
                            border: 1px solid #FF8C19;
                            -webkit-transform-origin: 0 0;
                            border-radius: 2px;
                            transform-origin: 0 0;
                            -webkit-transform: scale(0.5);
                            transform: scale(0.5);
                        }
                        .tag3 {
                            position: relative;
                            border: none;
                            display: inline-block;
                            margin-right: 12px;
                            color: #36B374;
                        }
                        .tag3:after {
                            content: " ";
                            position: absolute;
                            left: 0;
                            top: 0;
                            width: 200%;
                            height: 200%;
                            border: 1px solid #36B374;
                            -webkit-transform-origin: 0 0;
                            border-radius: 2px;
                            transform-origin: 0 0;
                            -webkit-transform: scale(0.5);
                            transform: scale(0.5);
                        }
                    }
                    .info1 {
                        display: flex;
                        margin-top: 12px;
                        font-size: 12px;
                        color: #777;
                        width: 100%;
                        .info1_title {
                            width: 80px;
                        }
                        .info1_certer {
                            margin-bottom: 12px;
                            .info1_span {
                                width: 100%;
                                display: inline-block;
                            }
                        }
                        .content_box {
                            display: flex;
                            flex-direction: column;
                            .tag {
                              margin-bottom: 6px;
                              display: flex;
                              .tag_content {
                                white-space: nowrap;
                                overflow: hidden;
                                text-overflow: ellipsis;
                                width:180px;
                              }
                              .tag1 {
                                position: relative;
                                border: none;
                                display: inline-block;
                                margin-right: 12px;
                                width: 48px;
                                color: #FF4D4D;
                              }
                              .tag1:after {
                                content: " ";
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 200%;
                                height: 200%;
                                border: 1px solid #FF4D4D;
                                -webkit-transform-origin: 0 0;
                                border-radius: 2px;
                                transform-origin: 0 0;
                                -webkit-transform: scale(0.5);
                                transform: scale(0.5);
                              }
                              .tag2 {
                                position: relative;
                                border: none;
                                display: inline-block;
                                margin-right: 12px;
                                color: #FF8C19;
                              }
                              .tag2:after {
                                content: " ";
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 200%;
                                height: 200%;
                                border: 1px solid #FF8C19;
                                -webkit-transform-origin: 0 0;
                                border-radius: 2px;
                                transform-origin: 0 0;
                                -webkit-transform: scale(0.5);
                                transform: scale(0.5);
                              }
                              .tag3 {
                                position: relative;
                                border: none;
                                display: inline-block;
                                margin-right: 12px;
                                color: #36B374;
                              }
                              .tag3:after {
                                content: " ";
                                position: absolute;
                                left: 0;
                                top: 0;
                                width: 200%;
                                height: 200%;
                                border: 1px solid #36B374;
                                -webkit-transform-origin: 0 0;
                                border-radius: 2px;
                                transform-origin: 0 0;
                                -webkit-transform: scale(0.5);
                                transform: scale(0.5);
                              }

                            }
                            div:nth-child(3n + 3) {
                              margin-bottom: 0px;
                            }

                        }
                    }

                }
                .line {
                    width: 100%;
                    height: 1px;
                    background-color: #eee;
                    margin-top: 6px;
                }
                .status {
                    width: 100%;
                    padding: 15px 16px;
                    box-sizing: border-box;
                    font-size: 18px;
                    color: #666;
                    display: flex;
                    justify-content: space-between;
                    p:nth-child(2) {
                        display: flex;
                        align-items: center;
                        span {
                            color: #999999;
                            font-size: 12px;
                        }
                        .info_text1{
                            font-size:12px;
                        }
                    }
                    .info_text{
                        font-size:14px;
                    }
                    p>span>img {
                        width: 4px;
                        height: 7px;
                        margin-left: 4px;
                        margin-top:-3px;
                    }
                }
            }
            .title {
                display: flex;
                justify-content: space-between;
                .title_text {
                    font-size: 16px;
                    font-weight: 700;
                    color: #2a2a2a;
                    text-overflow: ellipsis;
                    overflow: hidden;
                    white-space: nowrap;
                    line-height: 20px;
                }
                .title_tag {
                    width: 36px;
                    height: 18px;
                    font-size: 10px;
                    color: #ffffff;
                    border-radius: 9px;
                    text-align: center;
                    line-height: 18px;
                }
                .ss1 {
                    background: #118bf5;
                }
                .ss2 {
                    background: #ffa509;
                }
                .ss3 {
                    background: #f75c32;
                }
            }
            .space {
                width: 100%;
                height: 4px;
                background-color: #eee;
            }
        }
    }
    .box1 {
        text-align: center;
        margin-top: 64px;
        img {
            display: inline-block;
            width: 155px;
            height: 155px;
        }
        .tip1 {
            font-size: 14px;
            color: #9b9b9b;
            margin-top: 28px;
        }
        .tip2 {
            font-size: 14px;
            color: #9b9b9b;
            margin-top: 8px;
        }
    }
}
</style>
